import * as React from 'react';
const SvgArrowOutward = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>

        <g>
            <path
                fill='currentColor'
                d='m12.83 7.803-6.045 6.046a.53.53 0 0 1-.764.003.53.53 0 0 1-.163-.383.52.52 0 0 1 .16-.386l6.047-6.046H9.187a.56.56 0 0 1-.394-.149.51.51 0 0 1-.16-.392.55.55 0 0 1 .157-.397.55.55 0 0 1 .397-.146h4.08a.63.63 0 0 1 .452.19q.094.095.142.21.048.116.053.258v4.07q0 .233-.145.376a.57.57 0 0 1-.398.149.52.52 0 0 1-.392-.155.55.55 0 0 1-.148-.4z'
            />
        </g>
    </svg>
);
export default SvgArrowOutward;
